













import { Vue, Component } from "vue-property-decorator";
import { Utils } from "@/plugins/utils";
import { ApkStore } from "@/modules/apk/apk.store";
import { ApkDetection } from "@/modules/apk/apk.interface";
@Component({})
export default class ReportPage extends Vue {
  @ApkStore.State curApkDetection!: ApkDetection | null;
  @ApkStore.State curApkDetectionLoading!: boolean;

  @ApkStore.Action loadCurApkDetection: any;

  generateLoading = false;

  get id() {
    return this.$route.params.id;
  }
  created() {
    if (!this.id) {
      this.$router.push("/");
    } else {
      this.loadCurApkDetection(this.id);
    }
  }
  async generateReport() {
    let el = document.getElementById("report-generation");
    if (el) {
      this.generateLoading = true;
      await Utils.generatePdf(el, "检测报告.pdf");
      this.generateLoading = false;
    }
  }
}
